/** Решение «что показать на карточке лимита» — чистой функцией, отдельно от вёрстки.
 *
 * Вынесено из компонента намеренно: это единственное место в приложении, где
 * выбирается тон разговора о деньгах, и оно должно быть проверяемо без DOM.
 */
import type { Allowance } from "./api.ts";
import { formatMoney, ratio } from "./money.ts";
import { plural } from "./plural.ts";

/** Доля потраченного, с которой начинаем предупреждать (пороги бюджета, D-31). */
export const NEAR = 0.9;

export type Tone = "normal" | "near" | "over";

export type LimitView = {
  heading: string;
  amount: string;   // уже отформатировано; сырую строку наружу не отдаём
  sub: string;
  tone: Tone;
  share: number;    // 0..1+, только для ширины полосы
};

export function limitView(s: Allowance): LimitView {
  const share = ratio(s.spent, s.limit);
  const tone: Tone = s.is_over ? "over" : share >= NEAR ? "near" : "normal";
  const limit = formatMoney(s.limit, s.base_currency);
  const spent = formatMoney(s.spent, s.base_currency);
  const days = plural(s.days_left, ["день", "дня", "дней"]);

  // Три состояния отличаются ТЕКСТОМ, а не только цветом (WCAG 1.4.1). И ни одно
  // не осуждает: «перебрал» — это факт, а не приговор (ADR-0002, YNAB Rule 3).
  const heading =
    tone === "over" ? "Перебрал в этом месяце"
    // «На последние 1 день» — прилагательное не согласуется с числом.
    // «Осталось на N» падеж не меняет ни при одном числе.
    : tone === "near" ? `Осталось на ${days}`
    : "Осталось до конца месяца";

  return {
    heading,
    amount: formatMoney(tone === "over" ? s.over : s.left, s.base_currency),
    sub: `потрачено ${spent} из ${limit} · ${days}`,
    tone,
    share,
  };
}
